import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=4c636e0b&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=4c636e0b&prod&lang=scss&scoped=true"
import style1 from "./Settings.vue?vue&type=style&index=1&id=4c636e0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c636e0b",
  null
  
)

export default component.exports